var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"toast-fade"}},[(_vm.visible)?_c('div',{staticClass:"app-toast",class:`app-toast--${_vm.type}`},[_vm._v(" "+_vm._s(_vm.msg)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }